import * as React from "react";

import { concatStyleSets } from "@fluentui/react";

import { AppCheckbox, AppCheckboxInternalProps } from "@1js/acui-checkbox";
import { getModernUxExperimentPreference } from "@1js/acui-common";

import { getModernUxRibbonCheckboxStyles } from "../../../../styling";

export class RibbonCheckbox extends React.PureComponent<
  AppCheckboxInternalProps,
  {}
> {
  public render() {
    const styles = getModernUxExperimentPreference()
      ? concatStyleSets(this.props.styles, getModernUxRibbonCheckboxStyles())
      : this.props.styles;
    return (
      <AppCheckbox
        {...this.props}
        styles={styles}
        dataAutomationType="RibbonCheckbox"
      />
    );
  }
}
